export enum SortingCriteria {
    Asc,
    Desc
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/sortingCriteria.enum.ts